export const DEFAULT_FIELD_DISPLAY = { display_fields: ['title', 'lsd'], separator: ' - ' };
export const JOB_FIELD_DISPLAY = { display_fields: ['job_number', 'customer_name', 'location', 'lsd'], separator: ' - ' };
export const DISPLAY_FIELD_LABELS = { job_number: 'Job #', title: 'Title', customer_name: 'Customer', location: 'Location', lsd: 'LSD' };

const clean = (value) => String(value ?? '').trim();

export const formatFieldEvent = (event, preferences = DEFAULT_FIELD_DISPLAY) => {
  if (!event) return '';
  const title = clean(event.title) || 'Untitled event';
  let titleUsed = false;
  const parts = preferences.display_fields.map((field) => {
    const usesTitle = field === 'title' || (field === 'job_number' && !clean(event.job_number));
    if (usesTitle) {
      if (titleUsed) return '';
      titleUsed = true;
      return title;
    }
    return clean(event[field]);
  }).filter(Boolean);
  return parts.join(preferences.separator) || title;
};